import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutofocusDirective } from './autofocus/autofocus.directive';

@NgModule({
  imports: [CommonModule, AutofocusDirective],
  exports: [AutofocusDirective],
})
export class DirectivesModule {}
